import { watch } from 'vue';
import { ElMessage } from 'element-plus';
import { isObject } from 'lodash-es';
import { SocketTypeEnum } from '@/enum/webSocket';
import mitt from 'mitt';

const dataParse = (value) => {
  let data;
  try {
    data = JSON.parse(value);
  } catch (e) {
    ElMessage.error({
      message: 'socket消息解析失敗',
    });

    throw new Error(`socket消息解析失敗: ${value}`);
  }

  if (!isObject(data)) {
    ElMessage.error({
      message: 'socket消息異常',
    });

    throw new Error(`socket消息異常: ${value}`);
  }

  return data;
};

const useResponseInterceptors = (connectResult) => {
  const emitter = mitt();

  watch(connectResult.data, (value) => {
    const data = dataParse(value);

    const { type } = data;

    emitter.emit(type, data);
  });

  const resInterceptor = () => {};

  return {
    ...emitter,
    resInterceptor,
  };
};

/**
 * 用於做異常處理的hook
 * 提供了addListener給外部監聽指定類型的socket消息
 * @param connectResult 調用useWebSocket後的結果
 * @returns {{addResListener: (function(type: string, fn: (data: object) => void): void)}}
 */
export const useInterceptors = (connectResult) => {
  const { on: addResListener } = useResponseInterceptors(connectResult);

  addResListener(SocketTypeEnum.WARNING, (data) => {
    const { msg } = data;
    console.warn(data);
    ElMessage.warning({
      message: msg,
    });
  });

  addResListener(SocketTypeEnum.ERROR, (data) => {
    const { msg } = data;
    console.error(data);
    ElMessage.error({
      message: msg,
    });
  });

  return {
    addResListener,
  };
};
